"use strict";

import angular from "angular";
import routes from "./wanted.routes";
import WantedController from "./wanted.controller";

export default angular
  .module("dalApp.wanted", ["dalApp.auth", "ui.router"])
  .config(routes)
  .controller("WantedController", WantedController).name;



// WEBPACK FOOTER //
// ./client/app/wanted/index.js